import { findInSearchTerms, findInLocations, resetSearchInput } from './utils/searchUtils';
import { updateVisibleCards } from '../ProjectCard';
import { selectLayer, resetLayerSelection } from './utils/projectLayers';
import { resetFilter } from '../ProjectFilters';

/* eslint-disable import/prefer-default-export */
export function search(view, map, initialExtent = {}) {
  const parent = document.getElementById('js-project-search-from');
  const input = parent.querySelector('#js-project-search-input');
  const button = parent.querySelector('#js-project-search-button');
  const clearButton = parent.querySelector('#js-project-search-clear-button');
  const cards = document.querySelectorAll('.js-mol-project-card');
  parent.addEventListener('submit', (event) => {
    event.preventDefault();
  });
  clearButton.classList.remove('show-button');

  // Check input directly on event input
  input.addEventListener('input', async () => {
    const value = input.value;
    // Filter current input with possible search terms within the project card attributes
    const results = findInSearchTerms(value);

    if (!value) {
      view.graphics.removeAll();
      cards.forEach(card => card.classList.add('is-visible'));
      clearButton.classList.remove('show-button');
    } else {
      clearButton.classList.add('show-button');
    }

    // If there is a result found in search terms, location search is disabled by button click, instead it updates project cards directly
    if (results !== null) {
      button.disabled = true;
      const foundItem = [{ id: results.dataset.id, name: '', visible: true }];
      updateVisibleCards(foundItem);
      selectLayer(foundItem[0].id, map, view).then(r => r);
      const element = document.querySelector(`[data-id='${foundItem[0].id}']`);

      if (element) {
        element.classList.add('is-active');
      }

      // Set the term change event which is read by other functions to check if there is a stable term search result found
      parent.dispatchEvent(new CustomEvent('term-changed', { detail: true, bubbles: false }));
    } else {
      button.disabled = false;
      // Unset term search found event
      parent.dispatchEvent(new CustomEvent('term-changed', { detail: false, bubbles: false }));
      resetFilter();
      cards.forEach(card => card.classList.remove('is-active'));
    }
  });

  // Executes findLocation search not the project term search, is only with button click
  button.addEventListener('click', async () => {
    const value = input.value.trim();

    if (!value) {
      view.graphics.removeAll();
    }

    await findInLocations(view, value);
  });

  // Clears input and reset cards and map layers
  clearButton.addEventListener('click', () => {
    // first map functions
    view.goTo(initialExtent);
    resetLayerSelection(map);

    // then visibility and events
    resetSearchInput(view);
    clearButton.classList.remove('show-button');
    button.disabled = false;

    // Waiting for DOM, then reset all cards to visible
    /* eslint-disable no-restricted-globals */
    setTimeout(() => {
      cards.forEach((card) => {
        card.classList.add('is-visible');
      });
    }, 300);
    parent.dispatchEvent(new CustomEvent('term-changed', { detail: false, bubbles: false }));
  });
}


